// eslint-disable-next-line unicorn/prefer-module
module.exports = typeof window === 'undefined'
  ? () => null : () => window.location.href;
